<app-menu>
  <div class="manager-shell min-h-full bg-[var(--manager-bg)] text-[var(--manager-text)]" [attr.data-theme]="themeMode">
    <div class="mx-auto flex w-full max-w-[1840px] flex-col gap-3 px-3 py-3 sm:px-4 lg:px-5">
      <header class="manager-hero overflow-hidden rounded-[8px] border border-[var(--manager-border)] bg-[var(--manager-panel)] shadow-[0_18px_45px_var(--manager-shadow)]">
        <div class="flex flex-col gap-3 p-3 lg:flex-row lg:items-center lg:justify-between lg:p-4">
          <div class="min-w-0">
            <p class="manager-eyebrow">Admin Tools</p>
            <h1 class="manager-title">Menu Manager</h1>
            <div class="mt-2 flex flex-wrap gap-1.5">
              <span class="manager-pill"><i class="fa-solid fa-layer-group"></i>{{ menus.length }} Menus</span>
              <span class="manager-pill"><i class="fa-solid fa-list"></i>{{ subMenus.length }} Sub Menus</span>
              <span class="manager-pill"><i class="fa-solid fa-sitemap"></i>{{ subSubMenus.length }} Nested</span>
              <span class="manager-pill" [class.manager-pill--warning]="issueCount > 0"><i class="fa-solid fa-triangle-exclamation"></i>{{ issueCount }} Issues</span>
              <span class="manager-pill" [class.manager-pill--success]="productionHealthy" [class.manager-pill--warning]="productionAttentionCount > 0" [class.manager-pill--danger]="!!productionError" [title]="productionPillTitle"><i class="fa-solid" [ngClass]="productionPillIcon"></i>{{ productionPillLabel }}</span>
            </div>
          </div>

          <div class="flex flex-wrap items-center gap-2">
            <button type="button" class="manager-secondary-button" [routerLink]="['/permission_manager']">
              <i class="fa-solid fa-shield-halved"></i>
              <span>Permissions</span>
            </button>
            <button type="button" class="manager-secondary-button" [routerLink]="['/manage_menu_items']">
              <i class="fa-solid fa-users-gear"></i>
              <span>Role Access</span>
            </button>
            <button type="button" class="manager-secondary-button" (click)="refreshProductionStatus()" [disabled]="productionLoading">
              <i class="fa-solid" [ngClass]="productionLoading ? 'fa-circle-notch fa-spin' : 'fa-cloud-arrow-up'"></i>
              <span>Prod Status</span>
            </button>
            <button type="button" class="manager-icon-button" (click)="toggleTheme()">
              <i [class]="getThemeIcon()"></i>
              <span>{{ getThemeLabel() }}</span>
            </button>
          </div>
        </div>
      </header>

      <div *ngIf="errorMessage" class="manager-message manager-message--error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <div *ngIf="successMessage" class="manager-message manager-message--success">
        <i class="fa-solid fa-circle-check"></i>
        <span>{{ successMessage }}</span>
      </div>

      <section class="menu-editor-layout">
        <aside class="manager-panel menu-tree-panel">
          <div class="manager-section-header">
            <div>
              <p class="manager-eyebrow">Navigation</p>
              <h2 class="manager-section-title">Menu Tree</h2>
            </div>
            <button type="button" class="manager-primary-button" (click)="beginAddMenu()">
              <i class="fa-solid fa-plus"></i>
              <span>Menu</span>
            </button>
          </div>

          <div class="menu-tree-toolbar">
            <mat-form-field appearance="outline" class="manager-search-field">
              <mat-label>Search</mat-label>
              <i matPrefix class="fa-solid fa-magnifying-glass"></i>
              <input matInput [(ngModel)]="filterText" placeholder="Menu, route, icon...">
            </mat-form-field>
            <button type="button" class="manager-icon-button" (click)="refreshData()" [disabled]="loading">
              <i class="fa-solid" [ngClass]="loading ? 'fa-circle-notch fa-spin' : 'fa-rotate-right'"></i>
              <span>Refresh</span>
            </button>
          </div>

          <div class="menu-tree-meta">
            <span class="manager-pill"><i class="fa-solid fa-filter"></i>{{ visibleItemCount }} Shown</span>
            <span class="manager-pill"><i class="fa-solid fa-database"></i>{{ menus.length + subMenus.length + subSubMenus.length }} Total</span>
          </div>

          <div *ngIf="loading" class="manager-empty-state">
            <i class="fa-solid fa-circle-notch fa-spin"></i>
            <span>Loading menu tree</span>
          </div>

          <ng-container *ngIf="!loading">
            <div *ngIf="filteredMenus.length; else emptyTree" class="menu-tree-list">
              <article class="tree-node tree-node--menu" *ngFor="let menu of filteredMenus" [class.is-selected]="isSelected('menu', menu.ams_side_menu_id)">
                <div class="tree-node-row">
                  <button type="button" class="tree-node-main" (click)="selectMenu(menu)">
                    <span class="tree-node-icon"><i [class]="iconClass('menu', menu)"></i></span>
                    <span class="tree-node-text">
                      <strong>{{ menu.ams_side_menu_text || 'Untitled menu' }}</strong>
                      <small>{{ menu.children.length }} sub menus</small>
                    </span>
                    <span class="tree-node-order">{{ menu.ams_side_menu_order || 'Auto' }}</span>
                    <ng-container *ngIf="productionDiagnosticFor('menu', menu) as prodDiagnostic">
                      <span class="tree-node-prod" [ngClass]="'tree-node-prod--' + prodDiagnostic.tone" [title]="productionTitleFor('menu', menu)">
                        <i class="fa-solid" [ngClass]="prodDiagnostic.icon"></i>
                      </span>
                    </ng-container>
                  </button>

                  <div class="tree-node-actions">
                    <button type="button" class="tree-icon-action" (click)="beginAddSubMenu(menu)" title="Add sub menu">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                    <button type="button" class="tree-icon-action" (click)="moveMenu(menu, -1)" [disabled]="!canMoveMenu(menu, -1)" title="Move up">
                      <i class="fa-solid fa-chevron-up"></i>
                    </button>
                    <button type="button" class="tree-icon-action" (click)="moveMenu(menu, 1)" [disabled]="!canMoveMenu(menu, 1)" title="Move down">
                      <i class="fa-solid fa-chevron-down"></i>
                    </button>
                  </div>
                </div>

                <div *ngIf="warningDiagnosticsFor('menu', menu).length" class="tree-diagnostic-row">
                  <span class="diagnostic-chip" *ngFor="let diagnostic of warningDiagnosticsFor('menu', menu)" [ngClass]="'diagnostic-chip--' + diagnostic.tone">
                    <i class="fa-solid" [ngClass]="diagnostic.icon"></i>{{ diagnostic.label }}
                  </span>
                </div>

                <div class="tree-child-list" *ngIf="menu.children.length">
                  <article class="tree-node tree-node--sub" *ngFor="let subMenu of menu.children" [class.is-selected]="isSelected('subMenu', subMenu.ams_side_sub_menu_id)">
                    <div class="tree-node-row">
                      <button type="button" class="tree-node-main" (click)="selectSubMenu(subMenu)">
                        <span class="tree-node-icon"><i [class]="iconClass('subMenu', subMenu)"></i></span>
                        <span class="tree-node-text">
                          <strong>{{ subMenu.ams_side_sub_menu_text || 'Untitled sub menu' }}</strong>
                          <small>{{ routeLabel('subMenu', subMenu) }}</small>
                        </span>
                        <span class="tree-node-order">{{ subMenu.ams_side_sub_menu_order || 'Auto' }}</span>
                        <ng-container *ngIf="productionDiagnosticFor('subMenu', subMenu) as prodDiagnostic">
                          <span class="tree-node-prod" [ngClass]="'tree-node-prod--' + prodDiagnostic.tone" [title]="productionTitleFor('subMenu', subMenu)">
                            <i class="fa-solid" [ngClass]="prodDiagnostic.icon"></i>
                          </span>
                        </ng-container>
                      </button>

                      <div class="tree-node-actions">
                        <button type="button" class="tree-icon-action" (click)="beginAddSubSubMenu(subMenu)" title="Add nested menu">
                          <i class="fa-solid fa-plus"></i>
                        </button>
                        <button type="button" class="tree-icon-action" (click)="moveSubMenu(menu, subMenu, -1)" [disabled]="!canMoveSubMenu(menu, subMenu, -1)" title="Move up">
                          <i class="fa-solid fa-chevron-up"></i>
                        </button>
                        <button type="button" class="tree-icon-action" (click)="moveSubMenu(menu, subMenu, 1)" [disabled]="!canMoveSubMenu(menu, subMenu, 1)" title="Move down">
                          <i class="fa-solid fa-chevron-down"></i>
                        </button>
                      </div>
                    </div>

                    <div *ngIf="warningDiagnosticsFor('subMenu', subMenu).length" class="tree-diagnostic-row">
                      <span class="diagnostic-chip" *ngFor="let diagnostic of warningDiagnosticsFor('subMenu', subMenu)" [ngClass]="'diagnostic-chip--' + diagnostic.tone">
                        <i class="fa-solid" [ngClass]="diagnostic.icon"></i>{{ diagnostic.label }}
                      </span>
                    </div>

                    <div class="tree-grandchild-list" *ngIf="subMenu.children.length">
                      <article class="tree-node tree-node--nested" *ngFor="let nested of subMenu.children" [class.is-selected]="isSelected('subSubMenu', nested.ams_side_sub_sub_menu_id)">
                        <div class="tree-node-row">
                          <button type="button" class="tree-node-main" (click)="selectSubSubMenu(nested)">
                            <span class="tree-node-icon"><i [class]="iconClass('subSubMenu', nested)"></i></span>
                            <span class="tree-node-text">
                              <strong>{{ nested.ams_side_sub_sub_menu_text || 'Untitled nested menu' }}</strong>
                              <small>{{ routeLabel('subSubMenu', nested) }}</small>
                            </span>
                            <span class="tree-node-order">{{ nested.ams_side_sub_sub_menu_order || 'Auto' }}</span>
                            <ng-container *ngIf="productionDiagnosticFor('subSubMenu', nested) as prodDiagnostic">
                              <span class="tree-node-prod" [ngClass]="'tree-node-prod--' + prodDiagnostic.tone" [title]="productionTitleFor('subSubMenu', nested)">
                                <i class="fa-solid" [ngClass]="prodDiagnostic.icon"></i>
                              </span>
                            </ng-container>
                          </button>

                          <div class="tree-node-actions">
                            <button type="button" class="tree-icon-action" (click)="moveSubSubMenu(subMenu, nested, -1)" [disabled]="!canMoveSubSubMenu(subMenu, nested, -1)" title="Move up">
                              <i class="fa-solid fa-chevron-up"></i>
                            </button>
                            <button type="button" class="tree-icon-action" (click)="moveSubSubMenu(subMenu, nested, 1)" [disabled]="!canMoveSubSubMenu(subMenu, nested, 1)" title="Move down">
                              <i class="fa-solid fa-chevron-down"></i>
                            </button>
                          </div>
                        </div>

                        <div *ngIf="warningDiagnosticsFor('subSubMenu', nested).length" class="tree-diagnostic-row">
                          <span class="diagnostic-chip" *ngFor="let diagnostic of warningDiagnosticsFor('subSubMenu', nested)" [ngClass]="'diagnostic-chip--' + diagnostic.tone">
                            <i class="fa-solid" [ngClass]="diagnostic.icon"></i>{{ diagnostic.label }}
                          </span>
                        </div>
                      </article>
                    </div>
                  </article>
                </div>
              </article>
            </div>

            <ng-template #emptyTree>
              <div class="manager-empty-state">
                <i class="fa-solid fa-circle-info"></i>
                <span>No menu items match this search.</span>
              </div>
            </ng-template>
          </ng-container>
        </aside>

        <section class="manager-panel menu-detail-panel">
          <div class="manager-section-header menu-detail-header">
            <div class="min-w-0">
              <p class="manager-eyebrow">{{ editorMode === 'create' ? 'Creating' : 'Editing' }} {{ selectedKindLabel }}</p>
              <h2 class="manager-section-title">{{ selectedTitle }}</h2>
            </div>
            <div class="menu-create-actions">
              <button type="button" class="manager-secondary-button" (click)="beginAddSubMenu()" [disabled]="!canAddSubMenu">
                <i class="fa-solid fa-list"></i>
                <span>Sub Menu</span>
              </button>
              <button type="button" class="manager-secondary-button" (click)="beginAddSubSubMenu()" [disabled]="!canAddSubSubMenu">
                <i class="fa-solid fa-sitemap"></i>
                <span>Nested</span>
              </button>
            </div>
          </div>

          <div class="detail-diagnostic-strip">
            <span class="diagnostic-chip" *ngFor="let diagnostic of selectedDiagnostics" [ngClass]="'diagnostic-chip--' + diagnostic.tone">
              <i class="fa-solid" [ngClass]="diagnostic.icon"></i>{{ diagnostic.label }}
            </span>
          </div>

          <div *ngIf="selectedProductionDiffs.length" class="production-diff-row">
            <span class="production-diff-chip" *ngFor="let diff of selectedProductionDiffs">{{ diff }}</span>
          </div>

          <form [formGroup]="detailForm" class="manager-detail-form" (ngSubmit)="saveSelected()">
            <ng-container [ngSwitch]="selectedKind">
              <div *ngSwitchCase="'menu'" class="detail-form-grid">
                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Menu Text</mat-label>
                  <input matInput formControlName="ams_side_menu_text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Position</mat-label>
                  <input matInput type="number" formControlName="ams_side_menu_order" placeholder="Auto">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Description</mat-label>
                  <textarea matInput rows="2" formControlName="ams_side_menu_description"></textarea>
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'subMenu'" class="detail-form-grid">
                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Parent Menu</mat-label>
                  <mat-select formControlName="ams_side_menu_id">
                    <mat-option *ngFor="let menu of menus" [value]="menu.ams_side_menu_id">{{ menu.ams_side_menu_text }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Sub Menu Text</mat-label>
                  <input matInput formControlName="ams_side_sub_menu_text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Route</mat-label>
                  <input matInput formControlName="ams_side_sub_menu_page" placeholder="customer_rate_quote">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Position</mat-label>
                  <input matInput type="number" formControlName="ams_side_sub_menu_order" placeholder="Auto">
                </mat-form-field>

                <div class="detail-checkbox-row detail-field-span">
                  <mat-checkbox formControlName="ams_side_sub_sub_menu">Has nested menu items</mat-checkbox>
                </div>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Description</mat-label>
                  <textarea matInput rows="2" formControlName="ams_side_sub_menu_description"></textarea>
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'subSubMenu'" class="detail-form-grid">
                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Parent Sub Menu</mat-label>
                  <mat-select formControlName="ams_side_sub_menu_id">
                    <mat-option *ngFor="let item of parentSubMenuOptions" [value]="item.ams_side_sub_menu_id">{{ optionLabelForSubMenu(item) }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Nested Menu Text</mat-label>
                  <input matInput formControlName="ams_side_sub_sub_menu_text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Route</mat-label>
                  <input matInput formControlName="ams_side_sub_sub_menu_page" placeholder="customer_rate_quote">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Position</mat-label>
                  <input matInput type="number" formControlName="ams_side_sub_sub_menu_order" placeholder="Auto">
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Description</mat-label>
                  <textarea matInput rows="2" formControlName="ams_side_sub_sub_menu_description"></textarea>
                </mat-form-field>
              </div>
            </ng-container>

            <section *ngIf="selectedKind !== 'menu'" class="detail-icon-access" aria-label="Menu icon">
              <div class="icon-selection-row">
                <span class="icon-preview" aria-hidden="true"><i [class]="selectedIconClass || 'fa-solid fa-circle-dot'"></i></span>
                <mat-form-field appearance="outline" class="manager-search-field">
                  <mat-label>Icon Class</mat-label>
                  <input matInput [formControlName]="selectedKind === 'subMenu' ? 'ams_side_sub_menu_icon' : 'ams_side_sub_sub_menu_icon'" placeholder="fa-solid fa-truck" [readonly]="tripIconLocked" (pointerdown)="onIconFieldAttempt($event)" (paste)="onIconFieldAttempt($event)" (keydown)="onLockedIconKeydown($event)">
                </mat-form-field>
                <button type="button" class="manager-secondary-button" (click)="toggleIconPicker()" [attr.aria-expanded]="iconPickerOpen" aria-controls="menu-icon-picker">
                  <i class="fa-solid fa-icons" aria-hidden="true"></i>
                  <span>{{ iconPickerOpen ? 'Close Picker' : 'Choose Icon' }}</span>
                </button>
                <button *ngIf="selectedIconClass" type="button" class="tree-icon-action" (click)="chooseIcon('')" aria-label="Clear menu icon" title="Clear icon"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
              </div>

              <div *ngIf="iconPickerOpen" id="menu-icon-picker" class="icon-picker" aria-label="Font Awesome icon picker">
                <div class="icon-picker-toolbar">
                  <mat-form-field appearance="outline" class="manager-search-field">
                    <mat-label>Search Icons</mat-label>
                    <input matInput [(ngModel)]="iconSearch" [ngModelOptions]="{standalone: true}" (ngModelChange)="iconResultLimit = 72" (keydown.enter)="$event.preventDefault()" placeholder="truck, warehouse, user...">
                  </mat-form-field>
                  <select class="icon-style-select" aria-label="Icon style" [(ngModel)]="iconStyleFilter" [ngModelOptions]="{standalone: true}" (ngModelChange)="iconResultLimit = 72">
                    <option value="all">All styles</option>
                    <option value="solid">Solid</option>
                    <option value="regular">Regular</option>
                    <option value="brands">Brands</option>
                  </select>
                </div>
                <p class="role-access-note" aria-live="polite">{{ matchingIcons.length }} icons found. Click an icon to select it, then Save or Create the menu item.</p>
                <div class="icon-picker-grid">
                  <button *ngFor="let icon of visibleIcons; trackBy: trackIcon" type="button" class="icon-option" [class.is-selected]="selectedIconClass === icon.className" [attr.aria-pressed]="selectedIconClass === icon.className" [attr.aria-label]="icon.label + ' (' + icon.style + ')'" [title]="icon.className" (click)="chooseIcon(icon.className)">
                    <i [class]="icon.className" aria-hidden="true"></i>
                    <span>{{ icon.label }}</span>
                    <small>{{ icon.style }}</small>
                  </button>
                </div>
                <p *ngIf="!matchingIcons.length" class="role-access-note">No matching icons. Try another search or style.</p>
                <button *ngIf="matchingIcons.length > iconResultLimit" type="button" class="manager-secondary-button icon-show-more" (click)="iconResultLimit = iconResultLimit + 72">Show More Icons</button>
              </div>
            </section>

            <section class="detail-role-access" aria-label="Menu role access">
              <div class="detail-form-grid">
                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Allowed Roles</mat-label>
                  <mat-select multiple [value]="selectedAccessRoleValues" (selectionChange)="setAccessRoles($event.value)">
                    <mat-option *ngFor="let role of accessRoleOptions" [value]="role.value">{{ role.label }}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="manager-search-field detail-field-span">
                  <mat-label>Access Mask</mat-label>
                  <input matInput type="text" formControlName="access_roles" readonly>
                </mat-form-field>
              </div>
              <p class="role-access-note">Select one or more roles by name. The access mask updates automatically.</p>
              <p class="role-access-note">{{ selectedAccessRoleValues.length }} {{ selectedAccessRoleValues.length === 1 ? 'role selected.' : 'roles selected.' }} A mask of 1 means Admin.</p>
              <p *ngIf="unmappedAccessMask" class="role-access-note">This mask also contains unlisted role bits ({{ unmappedAccessMask }}), which will be preserved.</p>
            </section>

            <div class="detail-actions">
              <button type="button" class="manager-secondary-button" (click)="promoteSelectedToProduction()" [disabled]="!canPromoteSelected" [title]="promoteButtonTitle">
                <i class="fa-solid" [ngClass]="promoting ? 'fa-circle-notch fa-spin' : 'fa-cloud-arrow-up'"></i>
                <span>{{ promoting ? 'Sending...' : 'Send to Prod' }}</span>
              </button>
              <button type="button" class="manager-secondary-button" (click)="resetEditor()" [disabled]="saving">
                <i class="fa-solid fa-rotate-left"></i>
                <span>Reset</span>
              </button>
              <button type="submit" class="manager-primary-button" [disabled]="saving">
                <i class="fa-solid" [ngClass]="saving ? 'fa-circle-notch fa-spin' : 'fa-floppy-disk'"></i>
                <span>{{ saving ? 'Saving...' : (editorMode === 'create' ? 'Create' : 'Save') }}</span>
              </button>
            </div>
          </form>
        </section>
      </section>
    </div>
  </div>
</app-menu>
